var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticClass:"headline my-7 ml-2"},[_vm._v(" Bancos y efectivo ")]),_c('Period',{staticClass:"my-2"}),_c('BanksAndCashBalances',{staticClass:"my-2"}),_c('BanksAndCashTable',{staticClass:"my-2"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }